import translate from '@translate';
import { useLocation, useNavigate } from 'react-router-dom';
import { TabType } from 'src/components/Tabs';
import { useCheckPermission } from 'src/utils/checkPermission';

export const getAdminTopBlockParams = (): {
    tabs: TabType[];
    selected: string;
    handleChange: (newUrl: string) => void;
} => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleChange = (newUrl: string) => {
        navigate(`/admin/${newUrl}/`);
    };

    const selected = location.pathname.split('/')[2];

    const permissionRoles = useCheckPermission('ROLE.LIST');
    const permissionPermissions = useCheckPermission('PERMISSION.LIST');
    const permissionProviders = useCheckPermission('PROVIDER.LIST');
    const permissionSystem = useCheckPermission('ADMIN.LIST');
    const permissionConstants = useCheckPermission('CONSTATN.LIST');
    const permissionApplicationStatusMessages = useCheckPermission('APPLICATION_STATUS_MESSAGE.LIST');
    const permissionEmailTemplates = useCheckPermission('EMAIL_TEMPLATE.LIST');

    const tabs = [
        { value: 'providers', label: translate('admin.providers'), hidden: !permissionProviders },
        { value: 'system', label: translate('admin.system'), hidden: !permissionSystem },
        { value: 'constants', label: translate('admin.constants'), hidden: !permissionConstants },
        { value: 'roles', label: translate('admin.roles'), hidden: !permissionRoles },
        { value: 'permissions', label: translate('admin.permissions'), hidden: !permissionPermissions },
        {
            value: 'application_status_messages',
            label: translate('admin.applicationStatusMessages'),
            hidden: !permissionApplicationStatusMessages,
        },
        {
            value: 'email_templates',
            label: translate('admin.emailTemplates'),
            hidden: !permissionEmailTemplates,
        },
        { value: 'carriers', label: translate('admin.carriers'), hidden: !useCheckPermission('CARRIER.LIST') },
        { value: 'egon-routes', label: translate('admin.egonRoutes'), hidden: !useCheckPermission('EGON_ROUTE.LIST') },
    ];

    return {
        tabs,
        selected,
        handleChange,
    };
};
